/**
 * 優先度の定数定義
 *
 * ProposedJob の priority フィールド (1〜4) に対応する
 * ラベル・色・スタイルの単一定義ソース (Single Source of Truth)
 */

export const PRIORITY_OPTIONS = {
    1: { label: '◎', text: '最優先', color: '#1565c0', bg: '#e3f2fd', border: '#bbdefb' },
    2: { label: '○', text: '優先', color: '#2e7d32', bg: '#e8f5e9', border: '#c8e6c9' },
    3: { label: '△', text: '検討', color: '#e65100', bg: '#fff3e0', border: '#ffe0b2' },
    4: { label: '×', text: '見送り', color: '#c62828', bg: '#ffebee', border: '#ffcdd2' },
};

/**
 * 編集用トグルに渡す配列形式
 */
export const PRIORITY_LIST = [
    { value: 1, ...PRIORITY_OPTIONS[1] },
    { value: 2, ...PRIORITY_OPTIONS[2] },
    { value: 3, ...PRIORITY_OPTIONS[3] },
    { value: 4, ...PRIORITY_OPTIONS[4] },
];
